import React, { useMemo } from "react";
import "./confinedSpaceAllTemplate.css";

const Template4CS = ({ checklist }) => {
  console.log("checklist cwp", checklist);

  // Create a map using checklist_item_id as key for O(1) lookup
  const checklistMap = useMemo(() => {
    const map = {};
    checklist?.forEach((item) => {
      map[item.checklist_item_id] = item;
    });
    return map;
  }, [checklist]);

  // Define your checklist item IDs (these are from your data)
  const CHECKLIST_IDS = {
    // Left Column - Items 1-8
    EQUIPMENT_INSPECTED: "ee642835-a40b-11f0-81e8-9c2dcdaf01ba",
    AREA_CORDONED: "ee64c474-a40b-11f0-81e8-9c2dcdaf01ba",
    ELECTRICALLY_ISOLATED: "ee64c828-a40b-11f0-81e8-9c2dcdaf01ba",
    EQUIPMENT_STATUS: "ee64c904-a40b-11f0-81e8-9c2dcdaf01ba",
    VENTILATION_LIGHTING: "ee64c9a5-a40b-11f0-81e8-9c2dcdaf01ba",
    STEAM_PURGED: "ee64ca4d-a40b-11f0-81e8-9c2dcdaf01ba",
    IRON_SULPHIDE: "ee64caee-a40b-11f0-81e8-9c2dcdaf01ba",
    OIL_GAS_TRAPPED: "ee64d066-a40b-11f0-81e8-9c2dcdaf01ba",

    // Right Column - Items 9-16
    FW_HOSE: "ee64d2f1-a40b-11f0-81e8-9c2dcdaf01ba",
    SAFETY_SIGNAGE: "ee64d3e6-a40b-11f0-81e8-9c2dcdaf01ba",
    EQUIPMENT_DRAINED: "ee64d489-a40b-11f0-81e8-9c2dcdaf01ba",
    STANDBY_PERSON: "ee64d51b-a40b-11f0-81e8-9c2dcdaf01ba",
    EXIT_PROVIDED: "ee64d5a9-a40b-11f0-81e8-9c2dcdaf01ba",
    HC_GAS_TESTING: "ee64d63a-a40b-11f0-81e8-9c2dcdaf01ba",
    H2S_GAS_TESTING: "ee64d738-a40b-11f0-81e8-9c2dcdaf01ba",
    O2_GAS_TESTING: "ee64d7d5-a40b-11f0-81e8-9c2dcdaf01ba",
  };

  // Helper function to get checklist item by ID
  const getItem = (id) => checklistMap[id];

  // Helper function to render checkmark
  const renderCheckmark = (item, status) => {
    if (item && item.work_status === status) {
      return <span className="checkmarks">&#10003;</span>;
    }
    return "";
  };

  return (
    <>
      <div className="cs_template-container">
        <div className="template-container-content">
          <div className="template-container-header">
            <div className="cs-work-table">
              <table className="cold-work-tables">
                <thead>
                  <tr>
                    <th className="permit-center-align permit-1">
                      क्रम सं <br /> Sr.no
                    </th>
                    <th className="permit-center-align permit-2">
                      मद <br />
                      Item
                    </th>
                    <th className="permit-center-align permit-3">
                      किया गया <br /> Done
                    </th>
                    <th className="permit-center-align permit-4">
                      अपेक्षित नहीं <br /> Not Reqd.
                    </th>
                    <th className="permit-center-align permit-1">
                      क्रम सं <br /> Sr.no
                    </th>
                    <th className="permit-center-align permit-2">
                      मद <br />
                      Item
                    </th>
                    <th className="permit-center-align permit-3">
                      किया गया <br /> Done
                    </th>
                    <th className="permit-center-align permit-4">
                      अपेक्षित नहीं <br /> Not Reqd.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="permit-center-align">1</td>
                    <td>Equipment and area inspected</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED),
                        0
                      )}
                    </td>

                    <td className="permit-center-align">9</td>
                    <td>
                      FW hose, Portable extinguishers provided & FW system
                      checked.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.FW_HOSE), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.FW_HOSE), 0)}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">2</td>
                    <td>Area cordoned off.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.AREA_CORDONED), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.AREA_CORDONED), 0)}
                    </td>

                    <td className="permit-center-align">10</td>
                    <td>
                      Safety Signage boards(Not ready for entry/ Ready for
                      entry) displayed
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SAFETY_SIGNAGE),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SAFETY_SIGNAGE),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">3</td>
                    <td>
                      Equipment Electrically isolated & tagged. Electrical
                      Permit No.
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.ELECTRICALLY_ISOLATED)
                          ?.permit_no || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.ELECTRICALLY_ISOLATED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.ELECTRICALLY_ISOLATED),
                        0
                      )}
                    </td>

                    <td className="permit-center-align">11</td>
                    <td>Equipment properly drained & depressurized.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_DRAINED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_DRAINED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">4</td>
                    <td>
                      Equipment: Blinded/ Isolated/ Disconnected/ Closed/ Edge
                      open :
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.EQUIPMENT_STATUS)
                          ?.equipment_status || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STATUS),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STATUS),
                        0
                      )}
                    </td>

                    <td className="permit-center-align">12</td>
                    <td>
                      Standby person provided at the vessel entry(two persons
                      minimum)
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.STANDBY_PERSON),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.STANDBY_PERSON),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">5</td>
                    <td>Proper ventilation & lighting provided.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.VENTILATION_LIGHTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.VENTILATION_LIGHTING),
                        0
                      )}
                    </td>

                    <td className="permit-center-align">13</td>
                    <td>Proper means of exit provided</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EXIT_PROVIDED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EXIT_PROVIDED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">6</td>
                    <td>Equipment properly steam purged and water flushed</td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.STEAM_PURGED), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.STEAM_PURGED), 0)}
                    </td>

                    <td className="permit-center-align">14</td>
                    <td>
                      HC gas testing:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.HC_GAS_TESTING)?.hc_gas ||
                          "..."}{" "}
                        % LEL
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.HC_GAS_TESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.HC_GAS_TESTING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">7</td>
                    <td>Iron sulphide removed & kept wet.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.IRON_SULPHIDE),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.IRON_SULPHIDE),
                        0
                      )}
                    </td>

                    <td className="permit-center-align">15</td>
                    <td>
                      H2S gas testing:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.H2S_GAS_TESTING)?.h2s_gas ||
                          "..."}{" "}
                        PPM
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.H2S_GAS_TESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.H2S_GAS_TESTING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">8</td>
                    <td>
                      Checked for oil & gas trapped behind the lining in
                      Equipment.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.OIL_GAS_TRAPPED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.OIL_GAS_TRAPPED),
                        0
                      )}
                    </td>

                    <td className="permit-center-align">16</td>
                    <td>
                      O2 gas testing:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.O2_GAS_TESTING)?.o2_gas || "..."}{" "}
                        % by vol of air
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.O2_GAS_TESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.O2_GAS_TESTING),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Template4CS;